import React from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";

function ParagraphImage({
  imageFirst,
  image,
  TextComponent,
  applyImageClassName,
}) {
  return (
    <div
      className={`paragraph-image${setAdditionalClasses(
        ["image-first"],
        [imageFirst]
      )}`}
    >
      <div className="paragraph-image__text">{TextComponent}</div>
      <div className="fake-flex-20px"></div>
      <ReactVisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <img
            src={image}
            alt=""
            className={`paragraph-image__image${setAdditionalClasses(
              [applyImageClassName],
              [applyImageClassName]
            )}`}
            style={getVisibleSensorAnimation(
              isVisible,
              "fade-in-40px-scale 1s ease-out backwards"
            )}
          />
        )}
      </ReactVisibilitySensor>
    </div>
  );
}

export default ParagraphImage;
